import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { RouterModule, Routes } from '@angular/router';
import { MailLoginComponent } from './components/mail-login/mail-login.component';
import { MailComponent } from './components/mail/mail.component';
import { LoginModule } from '../login/login.module';
import { environment } from '../../../environments/environment';
import { MailOdooService } from './services/mail-odoo.service';
import { MailInMemoryService } from './services/mail-in-memory.service';
import { MailService } from './services/mail.service';
import { MailStateService } from './services/mail-state.service';
import { MailSubscribePageComponent } from './pages/mail-subscribe/mail-subscribe.page';
import { MailUnsubscribePageComponent } from './pages/mail-unsubscribe/mail-unsubscribe.page';
import { MailLoginGuard } from './guards/mail-login.guard';
import { MailConfirmComponent } from './components/mail-confirm/mail-confirm.component';

const routes: Routes = [{
  path: 'mail',
  component: MailComponent,
  children: [
    {
      path: 'login',
      component: MailLoginComponent,
      canActivate: [MailLoginGuard]
    },
    {
      path: 'subscribe-result',
      component: MailSubscribePageComponent,
    },
    {
      path: 'unsubscribe-result',
      component: MailUnsubscribePageComponent,
    },
    {
      path: 'subscribe/:mailHash',
      component: MailConfirmComponent,
      data: {
        'subscribe': true,
      }
    },
    {
      path: 'unsubscribe/:mailHash',
      component: MailConfirmComponent,
      data: {
        'subscribe': false,
      }
    },
  ]
},
];

const mailServiceClass = environment.production ? MailOdooService : MailInMemoryService;

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    GeneralModule,
    RouterModule.forChild(routes),
    LoginModule,

  ],
  declarations: [
    MailLoginComponent,
    MailComponent,
    MailSubscribePageComponent,
    MailUnsubscribePageComponent,
    MailConfirmComponent,
  ],
  exports: [
  ],
  providers: [
    MailStateService,
    MailLoginGuard,
    [{ provide: MailService, useClass: mailServiceClass }],
  ],
})

export class MailModule { }
